import { findLocationByInputAlias as findLocationByInputAliasOp } from '@gql/operations'
import { type GqlExecutor } from '@hopdrive/sdk-core'
import { normalizeInputForAlias } from '../../utils/normalize'
import type { Location } from '../../types'

export interface FindByAliasParams {
  customerId: number
  input: string
  executor?: GqlExecutor
}

/**
 * Fast path lookup: Find location by previously-seen input string.
 *
 * @see location-matching-algorithm.md#input-alias-lookup-query-fast-path
 */
export async function findLocationByAlias(params: FindByAliasParams): Promise<Location | null> {
  const normalizedInput = normalizeInputForAlias(params.input)

  const aliases = await findLocationByInputAliasOp(
    { customerId: params.customerId, inputAlias: normalizedInput },
    { executor: params.executor }
  )

  return (aliases?.[0]?.location as Location) ?? null
}
